import { z } from 'zod';
import { uuidSchema, positiveDecimalSchema } from './common';

export const expenseSplitSchema = z.object({
  assignedTo: uuidSchema.optional(),
  personName: z.string().max(120).optional(),
  email: z.string().email().toLowerCase().optional(),
  shareAmount: positiveDecimalSchema,
  isOwnerSplit: z.boolean().optional().default(false),
  note: z.string().max(500).optional(),
});
export type ExpenseSplitInput = z.infer<typeof expenseSplitSchema>;

export const createSplitsSchema = z.object({
  splits: z.array(expenseSplitSchema).min(1),
});
export type CreateSplitsInput = z.infer<typeof createSplitsSchema>;

export const updateSplitSchema = expenseSplitSchema.partial();
export type UpdateSplitInput = z.infer<typeof updateSplitSchema>;

export const markSplitPaidSchema = z.object({
  paidAt: z.string().datetime().optional(),
  note: z.string().max(500).optional(),
});
export type MarkSplitPaidInput = z.infer<typeof markSplitPaidSchema>;

export const bulkMarkPaidSchema = z.object({
  ids: z.array(uuidSchema).min(1).max(200),
});
export type BulkMarkPaidInput = z.infer<typeof bulkMarkPaidSchema>;

export const splitsFilterSchema = z.object({
  status: z.enum(['open', 'paid', 'all']).default('all'),
  periodId: uuidSchema.optional(),
});
export type SplitsFilterInput = z.infer<typeof splitsFilterSchema>;
